exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.email[data-v-0b1f015f] { padding-right: 10px;\n}\n", ""]);

// exports
